function LinkPro() {
  return null;
}
export default LinkPro;
